var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBedaMinerals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_343_1861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8122 0.766113L0.489746 11.7846L3.16817 14.6457L10.8122 6.48416L18.4834 14.6726L21.1618 11.8136L10.8122 0.766113Z",
    fill: "url(#paint0_radial_343_1861)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8123 7.88379L3.82281 15.3445L3.77246 15.3983L10.8123 22.9148L15.4351 17.9824L17.854 15.3983L17.8288 15.3714L10.8123 7.88379Z",
    fill: "url(#paint1_radial_343_1861)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_343_1861",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(15.0141 10.4437 -42.3721 5.19873 3.20809 2.66833)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#010A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081939"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_343_1861",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(10.2274 11.2883 -28.8634 5.61914 5.62416 9.93983)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#010A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081939"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_343_1861"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.6721,
    height: 22.1486,
    fill: "white",
    transform: "translate(0.489746 0.766113)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedaMinerals);
export default __webpack_public_path__ + "static/media/Beda-Minerals.bb44da024f5b0a95c42d86e66a56da5d.svg";
export { ForwardRef as ReactComponent };